/*
 *  -----------------------------------------------------------------------
 *    <copyright file="apollo.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { ApolloClient, HttpLink, ApolloLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { LocalState } from '@apollo/client/local-state';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import Settings from '../settings/settings';

export default {
    getClient: (cache: InMemoryCache) => {
        const authLink = setContext((_, { headers }) => ({
            headers: {
                ...headers,
                Authorization: Settings.token ? `Bearer ${Settings.token}` : '',
            },
        }));

        const httpLink = new HttpLink({
            uri: Settings.api.graphQlUrl(),
        });

        const wsLink = new GraphQLWsLink(
            createClient({
                url: Settings.api.graphQlWebSocketUrl(),
                shouldRetry: () => true,
                retryAttempts: 10,
            }),
        );

        const link = ApolloLink.split(
            // split based on operation type
            ({ query }) => {
                const definition = getMainDefinition(query);
                return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
            },
            wsLink,
            httpLink,
        );

        return new ApolloClient({
            cache,
            link: authLink.concat(link),
            devtools: { enabled: true },
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'cache-and-network',
                    // fetchPolicy: 'network-only',
                    errorPolicy: 'all',
                },
            },
            localState: new LocalState({
                resolvers: {},
            }),
        });
    },
};
